// client/marks/link/LinkMarkView.ts
import "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";
import "prosemirror-view";
import { LinkMarkEditorDialog } from "./link-mark-editor-dialog.js";
var LinkMarkView = class {
  constructor(mark, view, inline) {
    this.mark = mark;
    this.view = view;
    const link = document.createElement(`a`);
    const { href, target } = mark.attrs;
    link.style.cursor = "pointer";
    link.setAttribute("href", href);
    link.setAttribute("target", target);
    link.addEventListener("click", this.handleClick.bind(this));
    this.dom = link;
  }
  async handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const href = this.mark.attrs.href;
    const target = this.mark.attrs.target;
    const range = this.getMarkRange();
    await LinkMarkEditorDialog.editLink({ href, target, view: this.view, from: range.from, to: range.to });
  }
  getMarkRange() {
    const pos = this.view.posAtDOM(this.dom, 0);
    const node = this.view.state.doc.nodeAt(pos);
    if (!node) {
      throw new Error("Mark range could not be determined.");
    }
    const mark = node.marks.find((m) => m.type === this.mark.type);
    if (!mark) {
      throw new Error("Mark not found in the node.");
    }
    const from = pos;
    const to = pos + node.nodeSize;
    return { from, to };
  }
  update(mark) {
    if (mark.type !== this.mark.type)
      return false;
    this.mark = mark;
    this.dom.setAttribute("href", mark.attrs.href);
    return true;
  }
  destroy() {
    this.dom.removeEventListener("click", this.handleClick);
    this.dom = null;
  }
};
var linkMarkView = (mark, view, inline) => {
  return new LinkMarkView(mark, view, inline);
};
var linkPlugin = new Plugin({
  key: new PluginKey("link-markview-plugin"),
  props: {
    markViews: {
      link: linkMarkView
    }
  }
});
export {
  linkPlugin
};
